import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ArchiveBoxSvg = function ArchiveBoxSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.79 11.557H9.21v1.384h5.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 3.249h20v6h-.93v12H2.93v-12H2zm2.326 6h15.348v10.615H4.326zm16.279-4.615v3.23H3.395v-3.23z",
    clipRule: "evenodd"
  }));
};
export var ArchiveBox = function ArchiveBox(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ArchiveBoxSvg
  }));
};